// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-providers {
  width: 100%;
  min-height: 400px;
  padding: 12px 0 24px;
  font-family: "Lato", sans-serif;
  color: #ffffff;
  box-sizing: border-box;
}

.lotus-casino-providers__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin-bottom: 12px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  line-height: 19px;
}

.lotus-casino-providers__back .icon-angle-left {
  font-size: 14px;
  line-height: 1;
}

.lotus-casino-providers__back:hover {
  color: #ffffff;
}

.lotus-casino-providers__header {
  flex: 0 0 auto;
  margin-bottom: 16px;
}

.lotus-casino-providers__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0;
}

.lotus-casino-providers__title {
  margin: 0;
  height: 38px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
}

.lotus-casino-providers__close {
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
}

.lotus-casino-providers__close .icon-cross {
  font-size: 20px;
  line-height: 1;
}

.lotus-casino-providers__input-wrapper {
  display: none;
  position: relative;
  width: 100%;
  margin-top: 16px;
  flex: 0 0 auto;
}

.lotus-casino-providers__input-wrapper .icon-search-lite {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #aaa;
  pointer-events: none;
  z-index: 1;
}

.lotus-casino-providers__input-wrapper input {
  width: 100%;
  height: 45px;
  padding: 1px 12px 1px 43px;
  border: 1.5px solid #9d9c9d;
  border-radius: 8px;
  background: #262626;
  color: #ffffff;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}

.lotus-casino-providers__input-wrapper input::placeholder {
  color: #aaa;
}

.lotus-casino-providers__results {
  flex: 0 0 auto;
}

.lotus-casino-providers__section {
  margin-bottom: 8px;
}

.lotus-casino-providers__section--all {
  margin-top: 28px;
}

.lotus-casino-providers__grouped-title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.65);
  margin: 0 0 16px;
}

.lotus-casino-providers__grouped-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}

.lotus-casino-providers__group-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  box-sizing: border-box;
}

.lotus-casino-providers__group-card:hover {
  background: rgba(103, 175, 126, 0.1);
  border-color: rgba(103, 175, 126, 0.25);
}

.lotus-casino-providers__group-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.lotus-casino-providers__provider-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
  background: transparent;
}

.lotus-casino-providers__provider-icon.is-empty {
  display: inline-block;
  background: #1a1a1a;
}

.lotus-casino-providers__provider-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.lotus-casino-providers__group-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 12px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
}

.lotus-casino-providers__table-count {
  color: #9d9c9d;
  margin-right: 0;
  font-size: 14px;
  font-weight: 500;
}

.lotus-casino-providers__skeleton {
  height: 64px;
  border-radius: 8px;
  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);
  background-size: 200% 100%;
  animation: lotus-providers-shimmer 1.2s infinite;
}

.lotus-casino-providers__empty {
  grid-column: 1 / -1;
  padding: 16px 4px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
}

@keyframes lotus-providers-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 720px) {
  .lotus-casino-providers__grouped-grid {
    grid-template-columns: 1fr;
  }
}

/* Mobile providers page — Lotus list layout */
@media (max-width: 1119px) {
  .lotus-casino-providers {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 8px 8px 80px;
    background: #080808;
    min-height: calc(100vh - 60px);
    /* Do NOT use flex-grow children that steal height from results */
  }

  .lotus-casino-providers__back {
    display: none;
  }

  .lotus-casino-providers__header {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    gap: 16px;
    margin-bottom: 20px;
  }

  .lotus-casino-providers__title-row {
    flex: 0 0 auto;
  }

  .lotus-casino-providers__title {
    height: auto;
    font-size: 20px;
    font-weight: 700;
  }

  .lotus-casino-providers__close {
    display: inline-flex;
  }

  .lotus-casino-providers__input-wrapper {
    display: block;
    position: relative;
    margin-top: 0;
    flex: 0 0 auto;
    width: 100%;
  }

  .lotus-casino-providers__results {
    flex: 0 0 auto;
    width: 100%;
  }

  .lotus-casino-providers__section {
    margin-bottom: 0;
  }

  .lotus-casino-providers__section--all {
    margin-top: 32px;
    padding-top: 8px;
  }

  .lotus-casino-providers__grouped-title {
    font-size: 18px;
    font-weight: 700;
    color: #efefef;
    margin: 0 0 12px;
  }

  .lotus-casino-providers__section--all .lotus-casino-providers__grouped-title {
    margin-top: 0;
    margin-bottom: 14px;
  }

  .lotus-casino-providers__grouped-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .lotus-casino-providers__group-card {
    height: 56px;
    min-height: 56px;
    padding: 8px 0;
    border-radius: 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid #343434;
  }

  .lotus-casino-providers__group-card:hover {
    background: transparent;
    border-color: #343434;
  }

  .lotus-casino-providers__group-left {
    font-size: 14px;
    font-weight: 500;
  }

  .lotus-casino-providers__skeleton {
    height: 56px;
    border-radius: 0;
    border-bottom: 1px solid #343434;
  }

  .lotus-casino-providers__provider-icon {
    width: 40px;
    height: 40px;
    background: #1a1a1a;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/casino/LotusCasinoProvidersPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,iEAAiE;EACnE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":[".lotus-casino-providers {\n  width: 100%;\n  min-height: 400px;\n  padding: 12px 0 24px;\n  font-family: \"Lato\", sans-serif;\n  color: #ffffff;\n  box-sizing: border-box;\n}\n\n.lotus-casino-providers__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  margin-bottom: 12px;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  font-family: \"Lato\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 19px;\n}\n\n.lotus-casino-providers__back .icon-angle-left {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.lotus-casino-providers__back:hover {\n  color: #ffffff;\n}\n\n.lotus-casino-providers__header {\n  flex: 0 0 auto;\n  margin-bottom: 16px;\n}\n\n.lotus-casino-providers__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.lotus-casino-providers__title {\n  margin: 0;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.lotus-casino-providers__close {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.lotus-casino-providers__close .icon-cross {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.lotus-casino-providers__input-wrapper {\n  display: none;\n  position: relative;\n  width: 100%;\n  margin-top: 16px;\n  flex: 0 0 auto;\n}\n\n.lotus-casino-providers__input-wrapper .icon-search-lite {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n  color: #aaa;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.lotus-casino-providers__input-wrapper input {\n  width: 100%;\n  height: 45px;\n  padding: 1px 12px 1px 43px;\n  border: 1.5px solid #9d9c9d;\n  border-radius: 8px;\n  background: #262626;\n  color: #ffffff;\n  font-family: \"Lato\", sans-serif;\n  font-size: 14px;\n  box-sizing: border-box;\n  outline: none;\n}\n\n.lotus-casino-providers__input-wrapper input::placeholder {\n  color: #aaa;\n}\n\n.lotus-casino-providers__results {\n  flex: 0 0 auto;\n}\n\n.lotus-casino-providers__section {\n  margin-bottom: 8px;\n}\n\n.lotus-casino-providers__section--all {\n  margin-top: 28px;\n}\n\n.lotus-casino-providers__grouped-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.65);\n  margin: 0 0 16px;\n}\n\n.lotus-casino-providers__grouped-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n}\n\n.lotus-casino-providers__group-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 64px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.lotus-casino-providers__group-card:hover {\n  background: rgba(103, 175, 126, 0.1);\n  border-color: rgba(103, 175, 126, 0.25);\n}\n\n.lotus-casino-providers__group-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.lotus-casino-providers__provider-icon {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  flex-shrink: 0;\n  border-radius: 4px;\n  background: transparent;\n}\n\n.lotus-casino-providers__provider-icon.is-empty {\n  display: inline-block;\n  background: #1a1a1a;\n}\n\n.lotus-casino-providers__provider-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.lotus-casino-providers__group-right {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.lotus-casino-providers__table-count {\n  color: #9d9c9d;\n  margin-right: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.lotus-casino-providers__skeleton {\n  height: 64px;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #1a1a1a 25%, #252525 50%, #1a1a1a 75%);\n  background-size: 200% 100%;\n  animation: lotus-providers-shimmer 1.2s infinite;\n}\n\n.lotus-casino-providers__empty {\n  grid-column: 1 / -1;\n  padding: 16px 4px;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 14px;\n}\n\n@keyframes lotus-providers-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@media (max-width: 720px) {\n  .lotus-casino-providers__grouped-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Mobile providers page — Lotus list layout */\n@media (max-width: 1119px) {\n  .lotus-casino-providers {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 8px 8px 80px;\n    background: #080808;\n    min-height: calc(100vh - 60px);\n    /* Do NOT use flex-grow children that steal height from results */\n  }\n\n  .lotus-casino-providers__back {\n    display: none;\n  }\n\n  .lotus-casino-providers__header {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 auto;\n    gap: 16px;\n    margin-bottom: 20px;\n  }\n\n  .lotus-casino-providers__title-row {\n    flex: 0 0 auto;\n  }\n\n  .lotus-casino-providers__title {\n    height: auto;\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .lotus-casino-providers__close {\n    display: inline-flex;\n  }\n\n  .lotus-casino-providers__input-wrapper {\n    display: block;\n    position: relative;\n    margin-top: 0;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .lotus-casino-providers__results {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .lotus-casino-providers__section {\n    margin-bottom: 0;\n  }\n\n  .lotus-casino-providers__section--all {\n    margin-top: 32px;\n    padding-top: 8px;\n  }\n\n  .lotus-casino-providers__grouped-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #efefef;\n    margin: 0 0 12px;\n  }\n\n  .lotus-casino-providers__section--all .lotus-casino-providers__grouped-title {\n    margin-top: 0;\n    margin-bottom: 14px;\n  }\n\n  .lotus-casino-providers__grouped-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .lotus-casino-providers__group-card {\n    height: 56px;\n    min-height: 56px;\n    padding: 8px 0;\n    border-radius: 0;\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid #343434;\n  }\n\n  .lotus-casino-providers__group-card:hover {\n    background: transparent;\n    border-color: #343434;\n  }\n\n  .lotus-casino-providers__group-left {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .lotus-casino-providers__skeleton {\n    height: 56px;\n    border-radius: 0;\n    border-bottom: 1px solid #343434;\n  }\n\n  .lotus-casino-providers__provider-icon {\n    width: 40px;\n    height: 40px;\n    background: #1a1a1a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
